export const ROOT_FOLDER_ID = 'root'
